import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { usePriceAndFinanceDetails, usePaymentSummary } from '../PriceAndFinanceContext';
import PaymentSummaryUI from './PaymentSummary';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Error from '../PriceAndFinanceDetails/Error';
import { useFinance } from '../SelectProductsContext/SelectProductsProvider';
import { getPaymentSummary, getFinanceLevisDetails, combinePaymentAndSummary } from './service/utils';
import { FINANCE_FREQUENCY_LABEL } from '../../utils/constants';

const PaymentSummary = () => {
  const { t } = useTranslation();
  const [finance] = useFinance();
  const { isLoading, hasError, finance: priceDetails } = usePriceAndFinanceDetails() || {};
  const { isLoading: isSummaryLoading, hasError: hasSummaryError, data } = usePaymentSummary() || {};

  const { sitecoreContext } = useSitecoreContext() || {};
  const language = sitecoreContext?.language || 'en';

  const summaryDetails = data ? data?.finance : null;
  const financeOptions = FINANCE_FREQUENCY_LABEL[finance?.options];
  const registeringFees = priceDetails?.[finance?.options]?.levies;

  // map Payment summary details
  const paymentSummaryDetails = getPaymentSummary({ priceDetails, summaryDetails, t, financeOptions, language });
  const getFinanceLevies = getFinanceLevisDetails(registeringFees, summaryDetails, language);

  const paymentSummaryData = combinePaymentAndSummary(paymentSummaryDetails, getFinanceLevies);

  if (isLoading || isSummaryLoading) return <LoadingSpinner />;
  if (hasError || hasSummaryError) return <Error message={t('Sub-apps.PriceAndFinance.unableToLoadError')} />;
  return <PaymentSummaryUI paymentSummaryDetails={paymentSummaryData} />;
};

export default PaymentSummary;
